<template>
    <v-dialog v-model="exibirModal" :max-width="Modal.Confirmacao.larguraMaxima">
        <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
            <v-card-title class="modal_title primary white--text py-0" primary-title dark>
            <span>
                {{item.sequencial}} | Cancelar Lance
            </span>
                <v-spacer></v-spacer>
                <v-btn color="white" small icon flat @click="$emit('fechar')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="cancelar-lance__texto">
                <p class="mb-0">
                    Deseja realmente cancelar o lance de<br>
                    <strong>{{ item.valor | cdCurrency(prefix, casasDecimais) }}{{ suffix }}</strong> para <strong>{{item.sequencial}}</strong>?
                </p>
            </v-card-text>

            <v-card-actions class="px-3 py-2">
                <v-btn id="botaoFechar" @click="$emit('fechar')" flat outline color="botao-cancelar-color">
                    Não
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed id="botaoCancelar" @click="$emit('cancelarLance')">
                    Sim
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'LanceDesempateModalCancelar',
    props: ['exibirModal', 'item', 'casasDecimais', 'prefix', 'suffix'],
    data() {
        return {
            Modal
        }
    }
}
</script>

<style scoped lang="stylus">
    .cancelar-lance
        &__texto
            text-align center
            color #777

        &__acao
            text-align center
            margin-bottom 16px

            .botao
                color #777 !important
                border 0

            .botao:first-child
                margin-right 10px

            .botao-primario, .botao
                text-transform uppercase
                font-size 13px

            .botao-primario
                background-color var(--v-primary-base) !important
                color #fff !important
                border 1px solid var(--v-primary-base) !important
</style>